module.exports = __webpack_public_path__ + "img/product-116.b7a98a8d.jpg";